import React, { useState, useCallback } from "react"
import { Box, Typography, Button } from "@material-ui/core"
import { WhatsApp as WhatsAppIcon } from "@material-ui/icons"

import useStyles from "@/pages/Attendance/ReferralPopup/screens/ReferralLinkScreen/styles"
import {
	REFERRAL_COPY_FEEDBACK_DURATION_IN_MS,
	REFERRAL_WHATSAPP_MESSAGE
} from "@/pages/Attendance/ReferralPopup/constants"
import { ReferralLinkScreenProps } from "@/pages/Attendance/ReferralPopup/types"
import { stripProtocol } from "@/utils/url"

const buildWhatsappDeepLink = (referralLink: string): string => {
	const messageText = `${REFERRAL_WHATSAPP_MESSAGE} ${referralLink}`
	const encodedMessage = encodeURIComponent(messageText)
	return `https://wa.me/?text=${encodedMessage}`
}

const ReferralLinkScreen: React.FC<ReferralLinkScreenProps> = (props) => {
	const { referralLink, onGoToForm, onClose } = props
	const classes = useStyles()

	const [hasBeenCopied, setHasBeenCopied] = useState<boolean>(false)

	const handleCopyClick = useCallback(() => {
		navigator.clipboard.writeText(referralLink)
		setHasBeenCopied(true)

		setTimeout(() => {
			setHasBeenCopied(false)
		}, REFERRAL_COPY_FEEDBACK_DURATION_IN_MS)
	}, [referralLink])

	const handleBackClick = useCallback(() => {
		onGoToForm()
	}, [onGoToForm])

	const handleSendViaWhatsappClick = useCallback(() => {
		const deepLink = buildWhatsappDeepLink(referralLink)
		window.open(deepLink, "_blank")
		onClose()
	}, [referralLink, onClose])

	const copyButtonClassName = hasBeenCopied
		? `${classes.copyButton} ${classes.copyButtonCopied}`
		: classes.copyButton

	return (
		<Box>
			<Box className={classes.header}>
				<Typography className={classes.title}>
					{"Seu link de indicação, pronto para enviar."}
				</Typography>
				<Typography className={classes.subtitle}>
					{"Quem entrar por ele já chega marcado como sua indicação. Os R$ 200 continuam no seu nome."}
				</Typography>
			</Box>
			<Box className={classes.linkContainer}>
				<Typography className={classes.linkText}>
					{stripProtocol(referralLink)}
				</Typography>
				<Button
					type="button"
					className={copyButtonClassName}
					onClick={handleCopyClick}
					disableRipple
				>
					{hasBeenCopied ? "Copiado!" : "Copiar"}
				</Button>
			</Box>
			<Box className={classes.footer}>
				<Button
					type="button"
					className={classes.backLink}
					onClick={handleBackClick}
					disableRipple
				>
					{"Voltar e indicar pelo nome"}
				</Button>
				<Button
					type="button"
					className={classes.whatsappButton}
					classes={{ label: classes.whatsappButtonLabel }}
					onClick={handleSendViaWhatsappClick}
					disableElevation
				>
					<WhatsAppIcon className={classes.whatsappIcon} />
					{"Enviar no WhatsApp"}
				</Button>
			</Box>
		</Box>
	)
}

export default ReferralLinkScreen
